<template>
<v-container grid-list-sm class="pa-0">
	<v-layout row>
		<v-flex xs10 align-center justify-space-between>
			<jm-combobox type="location" v-model="selection" :label="label">
			</jm-combobox>
		</v-flex>

		<v-flex xs2 align-center justify-space-between>
			<v-btn-toggle v-model="actions" multiple>
				<v-btn flat title="Use geolocation" :disabled="geolocationDisabled">
					<v-icon>fa-map-marker-alt</v-icon>
				</v-btn>
				<v-btn flat title="Show map">
					<v-icon>fa-map-marked-alt</v-icon>
				</v-btn>
			</v-btn-toggle>
		</v-flex>
	</v-layout>
</v-container>
</template>

<script>
import JmCombobox from './Combobox'
import { Entity } from '@/assets/js/JMan/Entity'
import { jman } from '@/services/jman'

export default {
	name: "JmLocation",

	props: {
		label: String,
		value: [ Object, Array, String, Number, Boolean ],
	},

	data () {
		return {
			selection: [],
			actions: [],
			geolocation: navigator.geolocation,
			geolocationWatcherID: null,
			position: null
		};
	},

	watch: {
		selection (value, previous) {

			if (typeof value === 'string') {
				console.log("LOC STRING", value);
				//value = Entity.make({type: 4 /*Location*/, data: {name: value}}, jman);
			}

			console.log("LOC WATCH", value);
			if (value != previous) {
				console.log("LOC CHANGE");
				this.$emit('input', value);
			}
		},

		actions (value) {
			// Deal with geolocation
			if (value.includes(0)) {
				// Geolocation is on
				this.geolocationStart();
			} else {
				// Geolocation is off
				this.geolocationStop();
			}

			// Deal with the map
			if (value.includes(1)) {
				// Show the map
			} else {
				// Hide the map
			}
		}
	},

	computed: {
		geolocationDisabled () {
			return "geolocation" in navigator &&
				this.selection instanceof Entity &&
				!!this.selection.id;
		},

		locationHasGeo () {
			return this.selection instanceof Entity &&
			"geo" in this.selection.data;
		}
	},

	methods: {
		geolocationStop () {
			console.log("geolocationStop");
			if (this.geolocationWatcherID !== null) {
				this.geolocation.clearWatch(this.geolocationWatcherID);
			}
			this.geolocationWatcherID = null;
		},

		geolocationStart () {
			console.log("geolocationStart");
			if (this.geolocationWatcherID) {
				return; // Already running
			}

			this.geolocationWatcherID = this.geolocation.watchPosition( (position) => {
				this.position = position;
				let location = this.selection;
				if (!(location instanceof Entity)) {
					location = Entity.make({type: 4 /*Location*/, data: {}});
				}

				location = {
					...location,
					data: {
						...location.data,
						geo: {
							latitude: position.coords.latitude,
							longitude: position.coords.longitude
						}
					}
				};

				if (!location.data.name) {
					location.data.name = `${position.coords.latitude}, ${position.coords.longitude}`;
				}

				this.selection = [location];
			});
		}
	},

	components: {
		JmCombobox
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/InputWidgets/Location.vue